module.exports = __webpack_public_path__ + "media/newstyle/images/pocket-white-c8922bc3e148f0d9cf6121a209b20ce7.svg";